import styled, { keyframes } from 'styled-components';

import { mediaQuery } from '../../../../../styles/global';

const CircleBlurKeyframe = keyframes`
  0% { 
    opacity: 0;
   }
  100% {
    opacity: 1;
  }
`;

export const Wrapper = styled.div`
  position: relative;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const SectionTextContainer = styled.div`
  max-width: 800px;
  margin-bottom: 72px;
`;

export const Caption = styled.h3`
  font-family: ${({ theme }) => theme.fontFamily.bold};
  color: ${({ theme }) => theme.colors.white};
  font-size: 48px;
  margin: 0;
  line-height: 100%;
`;

export const SubCaption = styled.p`
  color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fontFamily.medium};
  font-size: 24px;
`;

export const ImageCaption = styled.p`
  font-family: ${({ theme }) => theme.fontFamily.medium};
  letter-spacing: 0.2em;
  font-size: 10px;
  text-transform: uppercase;
  text-align: center;
  margin-top: 15px;
  position: relative;
`;

export const Text = styled.p`
  color: ${({ theme }) => theme.colors.white75};
  font-size: 1rem;
  font-family: ${({ theme }) => theme.fontFamily.regular};
  line-height: 170%;
`;

export const PanelWrapper = styled.div`
  border-top-right-radius: 32px;
  border-top-left-radius: 32px;
  padding-top: 5rem;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 20%);
  margin: 40px 0 80px;

  ${mediaQuery.maxWidth.tablet} {
    border-radius: 0;
    padding-top: 3.5rem;
  }
`;

export const Section = styled.div`
  padding: 0 50px;
  margin-bottom: 160px;

  ${mediaQuery.maxWidth.tablet} {
    padding: 0 16px;
    margin-bottom: 116px;
  }
`;  

export const CtaWrapper = styled.div`
  margin: 40px 0;
`;

export const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  position: relative;
`;

export const SpacedWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 72px;
  align-items: center;
  justify-content: center;
  gap: 3rem;
  width: 100%;

  ${mediaQuery.maxWidth.custom(1200)} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const SpacedCaption = styled.div`
  font-family: ${({ theme }) => theme.fontFamily.bold};
  color: ${({ theme }) => theme.colors.white};
  font-size: 32px;
  margin: 0;
  line-height: 100%;
`;

export const SpacedTextWrapper = styled.div`
  gap: 32px;
  max-width: 400px;

  ${mediaQuery.maxWidth.custom(1200)} {
    max-width: 100%;
  }
`;

export const SpacedImageWrapper = styled.div`

`;

export const StatementsWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  padding: 50px 20px;
  gap: 2rem;

  ${mediaQuery.maxWidth.tablet} {
    flex-direction: column;
    padding: 50px 20px;
  }
`;

export const Statement = styled.div`
  max-width: 590px;
  width: 50%;
  display: flex;
  flex-direction: column;
  font-family: ${({ theme }) => theme.fontFamily.bold};
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 100%);
  padding: 48px;
  border-radius: 12px;

  ${mediaQuery.maxWidth.tablet} {
    width: 100%;
  }
`;

export const StatementCaption = styled.div`
  font-size: 2rem;
  margin-top: 1rem;
  color: ${({ theme }) => theme.colors.white};
  ${mediaQuery.maxWidth.phone} {
    font-size: 1.5rem;
  }
`;

export const StatementDescription = styled.p`
  font-size: 1rem;
  line-height: 24px;
  font-family: ${({ theme }) => theme.fontFamily.regular};
  color: ${({ theme }) => theme.colors.white75};
`;

export const CircleBlur = styled.div`
  position: absolute;
  top: -675px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 800px;
  z-index: -1;
  filter: blur(45px);
  animation: ${CircleBlurKeyframe};
  animation-duration: 2000ms;
  animation-fill-mode: forwards;
`;